module.exports = __webpack_public_path__ + "media/images/remove-eadfb97da5d0934897daad52880cc076.png";